import { useMutation } from '@tanstack/react-query';
import { updateEmailTemplate } from '../../services/marketing';
import useGetMarketingData from './useGetMarketingData';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useUpdateEmailTemplate({ onSuccess, onError }: Options = {}) {
  const {
    data: marketingData,
    isFetching: isFetchingMarketing,
    isEnabled,
  } = useGetMarketingData();

  return useMutation({
    mutationFn: async (templateId: number) => {
      if (!marketingData?.id || isFetchingMarketing || !isEnabled) return null;
      const result = await updateEmailTemplate(marketingData.id, templateId);
      return result;
    },
    onSuccess: async () => {
      await onSuccess?.();
    },
    onError,
  });
}

export default useUpdateEmailTemplate;
